<template>
  <div id="MyAsins">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card mb-2">
            <div class="space-between">
              <div class="mainHeading"></div>
              <div class="mb-1" style="display: flex">
                <date-range-picker v-model="dateRange" opens="left" :autoApply="true"
                  :locale-data="{ format: 'yyyy-mm-dd' }" @update="dateChange" style="border: none">
                </date-range-picker>
                <div>
                  <router-link to="/lqs-analyser-global" style="text-decoration: none">
                    <button style="width: max-content; float: right" class="btn navigationButton ml-2" type="button">
                      <i class="fa fa-arrow-left"></i>
                      <span style=""> Back</span>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="card">
            <div class="mt-2">
              <div v-if="!viewMyASINsData.data" class="no-data">No Data!</div>
              <table class="table" id="MyasinTable" style="width: 100%">
                <thead class="thead-normal">
                  <tr>
                    <th scope="col" v-for="th of viewMyASINsData.header" :key="th.key" class="p-2">
                      {{ th.lable }}
                    </th>
                  </tr>
                </thead>
                <tbody class="tbody-normal">
                  <tr v-for="(row, i) in viewMyASINsData.data" :key="i">
                    <td v-for="(d, j) in viewMyASINsData.header" :key="j" :style="[
                      d.key == 'product_name' ? { width: '50%' } : { width: '10%' },
                    ]">
                      <router-link :to="'/asins-detailed-global/' +
                        row.product_asin +
                        '/' +
                        dateRange.startDate +
                        '/' +
                        dateRange.endDate
                        " v-if="d.key == 'product_asin'">
                        <div style="text-transform: capitalize">
                          {{ row[d.key] }}
                        </div>
                      </router-link>
                      <a :href="'https://www.amazon.in/dp/' + row['product_asin']" target="_blanck"
                        v-else-if="d.key == 'product_name'" class="productName">
                        <div style="text-transform: capitalize; color: '#000000'">
                          {{ row[d.key] }}
                        </div>
                      </a>
                      <div v-else style="text-transform: capitalize">
                        {{ row[d.key] }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "LqsAnalyser",
  components: { LqsCard, Datepicker },

  data: function () {
    return {
      loader: false,
      viewMyASINsData: {},
      dateRange: {
        startDate: moment().subtract(1, "month"),
        endDate: moment(),
      },
    };
  },

  mounted() {
    this.dataAPIs();
  },
  methods: {
    dataAPIs() {
      this.formatDates();
      this.getMyASINsData();
    },
    formatDates() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
    },
    dateChange() {
      this.formatDates();
      this.getMyASINsData();
    },

    getMyASINsData() {
      let self = this;
      self.loader = true;
      self.viewMyASINsData = {};
      let payload = {
        start: this.dateRange.startDate,
        end: this.dateRange.endDate,
      };
      const url = "/api/global_demo/viewasincount";
      self.$http
        .post(url, payload)
        .then((response) => {
          if (Object.keys(response.data.data.data).length)
            self.viewMyASINsData = response.data.data;
          self.$nextTick(() => {
            $("#MyasinTable").dataTable();
            $("#MyasinTable").DataTable().destroy();
            $("#MyasinTable").DataTable({
              autoWidth: false,
              sorting:false,
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
              },
              pagingType: "full_numbers",
            });
            let search = require("../../../../public/Icons_SVG/Search.svg");
            $("#MyasinTable_filter > label > input").attr("placeholder", "Search");
            $("#MyasinTable_filter > label").append(`<div><img src='${search}' /></div>`);
            $("#MyasinTable_length > label > select").removeClass();
          });
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          console.log("err");
        });
    },
  },
};
</script>

<style scoped>
.space-between {
  display: flex;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  justify-content: start;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.falseIcon {
  color: #ff0000 !important;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.productImg {
  width: 200px;
}

.product-title {
  font-size: 18px;
}

.productImg img {
  width: 100%;
}

.graphCount {
  font-size: 24px;
  color: "#533a79";
  font-weight: 700;
}

.asinBadge {
  /* background: '#9683b3'; */
  background: "#9683b3";
}

.cross-icon {
  color: black;
  background: white;
}

.crossIcon {
  cursor: pointer;
  font-size: 8px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.pinkColor {
  background: rgb(255 185 185);
  font-weight: bold;
}

.skyColor {
  background: rgb(199 224 255);
  font-weight: bold;
}

.no-data {
  font-size: 16px;
  text-align: center;
  padding: 10px;
  color: red;
}

.details-btn {
  background: #533a79;
  color: white;
  border-radius: 0;
  padding: 3px 22px;
  border: 1.6px solid #533a79;
}

.productName {
  color: #5a5a5a;
  text-align: left;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
</style>
<style>
#MyasinTable_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#MyasinTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#MyasinTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#MyasinTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#MyasinTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#MyasinTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#MyasinTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#MyasinTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#MyasinTable_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  z-index: 100;
  /* float: right; */
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#MyasinTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#MyasinTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#MyasinTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#MyasinTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#MyasinTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#MyasinTable {
  border-radius: 20px 20px 0 0 !important;
}

#MyasinTable .thead-normal,
#MyasinTable .thead-normal tr:first-child,
#MyasinTable .thead-normal>tr:first-child>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0 !important;
  border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr:last-child>th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr:first-child>th:last-child {
  border-radius: 0 21px 0 0;
}

#MyasinTable .thead-normal>tr:first-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px 0px 25px !important;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr:last-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#MyasinTable .thead-normal>tr>th.sorting:before {
  font-size: 12px;
  bottom: 60%;
  color: var(--base_color-80);
}

#MyasinTable .thead-normal>tr>th.sorting:after {
  font-size: 12px;
  top: 50%;
  color: var(--base_color-80);
}

#MyasinTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#MyasinTable tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#MyasinTable tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#MyasinTable tbody td {
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#MyasinTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#MyasinTable .even td {
  background: #fff !important;
}

#MyasinTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #MyasinTable_wrapper .bottom {
  margin: -30px;
} */
#MyasinTable_wrapper>.row:last-child {
  margin-bottom: 15px;
}

#MyasinTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}

#MyasinTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>
